import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {

  API: string = environment.baseURL;

  constructor(
    private httpClient: HttpClient
  ) { }

  getClients(request: { nbByPage: number, start: number, search: {columnSearch?: string}, token: string  }): Observable<any> {
    return this.httpClient.post(
      `${this.API}/getClientSet`, request
    );
  }

  getClientInfos(id: number): Observable<any> {
    const request = {
      id: id
    };
    return this.httpClient.post(
      `${this.API}/getClientDetail`, request
    );
  }
}
